import React from 'react';
import { ICustomIconProps } from '../types';

const IconModelConfiguration: React.FC<ICustomIconProps> = ({ size = 20, color = 'currentColor', className = '' }) => (
  <svg width={size} height={size} viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg' className={className}>
    <path
      d='M7.49996 18.3332H12.5C16.6666 18.3332 18.3333 16.6665 18.3333 12.4998V7.49984C18.3333 3.33317 16.6666 1.6665 12.5 1.6665H7.49996C3.33329 1.6665 1.66663 3.33317 1.66663 7.49984V12.4998C1.66663 16.6665 3.33329 18.3332 7.49996 18.3332Z'
      stroke={color}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path d='M12.975 15.4165V12.1665' stroke={color} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M12.975 6.2085V4.5835' stroke={color} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' strokeLinejoin='round' />
    <path
      d='M12.975 10.5418C14.1716 10.5418 15.1417 9.57178 15.1417 8.37516C15.1417 7.17855 14.1716 6.2085 12.975 6.2085C11.7784 6.2085 10.8083 7.17855 10.8083 8.37516C10.8083 9.57178 11.7784 10.5418 12.975 10.5418Z'
      stroke={color}
      strokeWidth='1.5'
      strokeMiterlimit='10'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path d='M7.02502 15.4165V13.7915' stroke={color} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M7.02502 7.8335V4.5835' stroke={color} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' strokeLinejoin='round' />
    <path
      d='M7.02494 13.7918C8.22156 13.7918 9.19161 12.8218 9.19161 11.6252C9.19161 10.4285 8.22156 9.4585 7.02494 9.4585C5.82833 9.4585 4.85828 10.4285 4.85828 11.6252C4.85828 12.8218 5.82833 13.7918 7.02494 13.7918Z'
      stroke={color}
      strokeWidth='1.5'
      strokeMiterlimit='10'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export default IconModelConfiguration;
